var oe = Object.defineProperty;
var se = (e, t, n) => t in e ? oe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var q = (e, t, n) => se(e, typeof t != "symbol" ? t + "" : t, n);
import { jsx as i, jsxs as N } from "react/jsx-runtime";
import * as ae from "react";
import { Component as ce, useState as A, useEffect as P, useRef as x, useCallback as g, forwardRef as J, createElement as O } from "react";
import * as ie from "react-dom";
import h, { css as U, keyframes as F } from "styled-components";
class le extends ce {
  constructor() {
    super(...arguments);
    q(this, "state", {
      hasError: !1
    });
  }
  static getDerivedStateFromError() {
    return {
      hasError: !0
    };
  }
  componentDidCatch(n, o) {
    var s, a;
    console.error("Chat UI widget crashed during render:", n), (a = (s = this.props).onError) == null || a.call(s, n);
  }
  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
const de = "https://voxityai-chat-widget.web.app/widget.js", H = "data-actions-chat-ui-widget", G = /* @__PURE__ */ new Map(), ue = ({ widgetUrl: e }) => {
  var n;
  const t = (n = window.ActionsChatUIWidget) == null ? void 0 : n.ChatUI;
  if (!t)
    throw new Error(`Chat UI widget did not register from ${e}`);
  return t;
}, pe = ({ widgetUrl: e }) => new Promise((t, n) => {
  var a;
  const o = document.querySelector(
    `script[${H}="${e}"]`
  );
  if (o) {
    if ((a = window.ActionsChatUIWidget) != null && a.ChatUI) {
      t();
      return;
    }
    o.addEventListener("load", () => t(), { once: !0 }), o.addEventListener(
      "error",
      () => n(new Error(`Failed to load chat UI widget from ${e}`)),
      { once: !0 }
    );
    return;
  }
  const s = document.createElement("script");
  s.src = e, s.async = !0, s.setAttribute(H, e), s.onload = () => t(), s.onerror = () => n(new Error(`Failed to load chat UI widget from ${e}`)), document.head.appendChild(s);
}), he = ({ widgetUrl: e }) => {
  const t = G.get(e);
  if (t)
    return t;
  window.React = ae, window.ReactDOM = ie;
  const n = pe({ widgetUrl: e }).then(
    () => ue({ widgetUrl: e })
  );
  return G.set(e, n), n;
}, ht = ({
  widgetUrl: e = de,
  onError: t,
  ...n
}) => {
  const [o, s] = A(null);
  return P(() => {
    let u = !0;
    return he({ widgetUrl: e }).then((c) => {
      u && s(() => c);
    }).catch((c) => {
      u && (t == null || t(c));
    }), () => {
      u = !1;
    };
  }, [e, t]), o ? /* @__PURE__ */ i(le, { onError: t, children: /* @__PURE__ */ i(o, { ...n }) }) : null;
}, me = async ({
  server: e,
  getIdToken: t
}) => {
  const n = e.endsWith("/") ? e.slice(0, -1) : e, o = await t(), s = await fetch(`${n}/voice/transcription-token`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${o}`
    }
  });
  if (!s.ok)
    throw new Error(`Failed to fetch transcription token (status ${s.status})`);
  return await s.json();
}, fe = "wss://api.deepgram.com/v1/listen", ge = () => new URLSearchParams({
  model: "nova-3",
  language: "multi",
  interim_results: "true",
  smart_format: "true",
  punctuate: "true"
}).toString(), be = ({ accessToken: e }) => new WebSocket(`${fe}?${ge()}`, ["bearer", e]), xe = 250, ye = () => ["audio/webm;codecs=opus", "audio/webm", "audio/mp4"].find((t) => MediaRecorder.isTypeSupported(t)), ke = async ({ onAudioChunk: e }) => {
  const t = await navigator.mediaDevices.getUserMedia({ audio: !0 }), n = ye(), o = new MediaRecorder(t, n ? { mimeType: n } : void 0);
  return o.ondataavailable = (s) => {
    s.data.size > 0 && e({ chunk: s.data });
  }, o.start(xe), { stream: t, recorder: o };
}, we = ({ languageCounts: e }) => {
  const t = Object.entries(e).sort(
    ([, n], [, o]) => o - n
  );
  return t.length === 0 ? "unknown" : t[0][0];
}, Ce = ({ failure: e }) => {
  if (e instanceof DOMException) {
    if (e.name === "NotAllowedError" || e.name === "PermissionDeniedError")
      return "Microphone access was denied. Allow microphone access in your browser settings and try again.";
    if (e.name === "NotFoundError")
      return "No microphone was found. Connect a microphone and try again.";
    if (e.name === "NotReadableError")
      return "Your microphone is in use by another application.";
  }
  return e instanceof Error && e.message.includes("transcription token") ? "Voice input is unavailable right now. Please try again in a moment." : e instanceof Error && e.message ? e.message : "Voice input failed. Please try again.";
}, ve = JSON.stringify({ type: "CloseStream" }), Ee = 3e3, mt = ({
  server: e,
  getIdToken: t,
  onInterimTranscript: n,
  onTranscriptionComplete: o
}) => {
  const [s, a] = A("idle"), [u, c] = A(null), [y, f] = A(null), l = x(null), k = x(null), E = x([]), S = x([]), w = x(""), M = x({}), R = x(null), T = x({ onInterimTranscript: n, onTranscriptionComplete: o });
  T.current = { onInterimTranscript: n, onTranscriptionComplete: o };
  const m = g(() => {
    const r = k.current;
    r && (r.recorder.state !== "inactive" && r.recorder.stop(), r.stream.getTracks().forEach((p) => p.stop()), k.current = null), f(null);
  }, []), b = g(() => {
    R.current && (clearTimeout(R.current), R.current = null);
  }, []), C = g(() => {
    E.current = [], S.current = [], w.current = "", M.current = {};
  }, []), $ = g(() => {
    const r = [...S.current];
    return w.current && r.push(w.current), r.join(" ").trim();
  }, []), z = g(
    (r) => {
      var _, V;
      if (typeof r.data != "string")
        return;
      let p;
      try {
        p = JSON.parse(r.data);
      } catch {
        return;
      }
      if (p.type !== "Results")
        return;
      const d = (V = (_ = p.channel) == null ? void 0 : _.alternatives) == null ? void 0 : V[0], v = (d == null ? void 0 : d.transcript) ?? "";
      v.trim() && (p.is_final ? (S.current.push(v.trim()), w.current = "", ((d == null ? void 0 : d.languages) ?? ((d == null ? void 0 : d.words) ?? []).map((I) => I.language).filter((I) => !!I)).forEach((I) => {
        M.current[I] = (M.current[I] ?? 0) + 1;
      })) : w.current = v.trim(), T.current.onInterimTranscript({ text: $() }));
    },
    [$]
  ), j = g(() => {
    b(), m(), l.current = null;
    const r = $();
    r && T.current.onTranscriptionComplete({
      transcript: r,
      detectedLanguage: we({
        languageCounts: M.current
      })
    }), C();
  }, [$, b, m, C]), D = g(
    (r) => {
      b(), m();
      const p = l.current;
      l.current = null, p && p.readyState !== WebSocket.CLOSED && (p.onclose = null, p.close()), C(), c(Ce({ failure: r })), a("error");
    },
    [b, m, C]
  ), ee = g(async () => {
    if (!(l.current || k.current)) {
      c(null), a("connecting"), C();
      try {
        const r = await ke({
          onAudioChunk: ({ chunk: v }) => {
            const _ = l.current;
            _ && _.readyState === WebSocket.OPEN ? _.send(v) : E.current.push(v);
          }
        });
        k.current = r, f(r.stream);
        const p = await me({ server: e, getIdToken: t }), d = be({ accessToken: p.accessToken });
        l.current = d, d.onopen = () => {
          E.current.forEach((v) => d.send(v)), E.current = [], a("listening");
        }, d.onmessage = z, d.onerror = () => D(new Error("Transcription connection failed")), d.onclose = () => {
          j(), a("idle");
        };
      } catch (r) {
        D(r);
      }
    }
  }, [D, j, t, z, C, e]), te = g(() => {
    m();
    const r = l.current;
    r && r.readyState === WebSocket.OPEN ? (r.send(ve), R.current = setTimeout(() => {
      r.close();
    }, Ee)) : r ? r.close() : a("idle");
  }, [m]), ne = g(() => {
    b(), m();
    const r = l.current;
    l.current = null, r && (r.onopen = null, r.onmessage = null, r.onerror = null, r.onclose = null, r.readyState !== WebSocket.CLOSED && r.close()), C(), c(null), a("idle");
  }, [b, m, C]), re = g(() => {
    c(null), a("idle");
  }, []);
  return P(() => () => {
    b(), m();
    const r = l.current;
    r && (r.onclose = null, r.close(), l.current = null);
  }, [b, m]), {
    micState: s,
    errorMessage: u,
    mediaStream: y,
    start: ee,
    stop: te,
    cancel: ne,
    dismissError: re
  };
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Se = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Me = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, n, o) => o ? o.toUpperCase() : n.toLowerCase()
), X = (e) => {
  const t = Me(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, K = (...e) => e.filter((t, n, o) => !!t && t.trim() !== "" && o.indexOf(t) === n).join(" ").trim(), Re = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Te = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _e = J(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: o,
    className: s = "",
    children: a,
    iconNode: u,
    ...c
  }, y) => O(
    "svg",
    {
      ref: y,
      ...Te,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: o ? Number(n) * 24 / Number(t) : n,
      className: K("lucide", s),
      ...!a && !Re(c) && { "aria-hidden": "true" },
      ...c
    },
    [
      ...u.map(([f, l]) => O(f, l)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const L = (e, t) => {
  const n = J(
    ({ className: o, ...s }, a) => O(_e, {
      ref: a,
      iconNode: t,
      className: K(
        `lucide-${Se(X(e))}`,
        `lucide-${e}`,
        o
      ),
      ...s
    })
  );
  return n.displayName = X(e), n;
};
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ie = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], Ae = L("check", Ie);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Le = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], $e = L("loader-circle", Le);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pe = [
  ["line", { x1: "2", x2: "22", y1: "2", y2: "22", key: "a6p6uj" }],
  ["path", { d: "M18.89 13.23A7.12 7.12 0 0 0 19 12v-2", key: "80xlxr" }],
  ["path", { d: "M5 10v2a7 7 0 0 0 12 5", key: "p2k8kg" }],
  ["path", { d: "M15 9.34V5a3 3 0 0 0-5.68-1.33", key: "1gzdoj" }],
  ["path", { d: "M9 9v3a3 3 0 0 0 5.12 2.12", key: "r2i35w" }],
  ["line", { x1: "12", x2: "12", y1: "19", y2: "22", key: "x3vr5v" }]
], De = L("mic-off", Pe);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Be = [
  ["path", { d: "M12 19v3", key: "npa21l" }],
  ["path", { d: "M19 10v2a7 7 0 0 1-14 0v-2", key: "1vc78b" }],
  ["rect", { x: "9", y: "2", width: "6", height: "13", rx: "3", key: "s6n7sd" }]
], Y = L("mic", Be);
/**
 * @license lucide-react v0.525.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Oe = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], Q = L("x", Oe), W = U`
    @media (prefers-reduced-motion: reduce) {
        animation: none !important;
        transition: none !important;
    }
`, Ue = F`
    0% {
        box-shadow: 0 0 0 0 hsl(0 84% 60% / 0.5);
    }
    70% {
        box-shadow: 0 0 0 8px hsl(0 84% 60% / 0);
    }
    100% {
        box-shadow: 0 0 0 0 hsl(0 84% 60% / 0);
    }
`, Ne = F`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`, Fe = h.span`
    display: flex;
    align-items: center;
    justify-content: center;
    animation: ${Ne} 1s linear infinite;
    ${W}
`, We = h.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background-color: transparent;
    color: hsl(var(--muted-foreground));
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;

    &:hover:not(:disabled) {
        background-color: hsl(var(--accent));
        color: hsl(var(--accent-foreground));
    }

    &:active:not(:disabled) {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    ${({ $micState: e }) => e === "listening" && U`
            background-color: hsl(0 84% 60%);
            color: white;
            animation: ${Ue} 1.5s ease-out infinite;
            ${W}

            &:hover:not(:disabled) {
                background-color: hsl(0 84% 52%);
                color: white;
            }
        `}

    ${({ $micState: e }) => e === "error" && U`
            color: hsl(0 84% 60%);
        `}
`, Z = ({
  micState: e,
  errorMessage: t
}) => e === "listening" ? "Stop and insert transcription" : e === "connecting" ? "Connecting..." : e === "error" ? t ?? "Voice input failed. Click to retry." : "Dictate a message", ft = ({ micState: e, errorMessage: t, onToggle: n }) => /* @__PURE__ */ N(
  We,
  {
    type: "button",
    $micState: e,
    onClick: n,
    disabled: e === "connecting",
    "aria-label": Z({ micState: e, errorMessage: t }),
    title: Z({ micState: e, errorMessage: t }),
    children: [
      e === "connecting" && /* @__PURE__ */ i(Fe, { children: /* @__PURE__ */ i($e, { size: 16 }) }),
      e === "listening" && /* @__PURE__ */ i(Y, { size: 16 }),
      e === "error" && /* @__PURE__ */ i(De, { size: 16 }),
      e === "idle" && /* @__PURE__ */ i(Y, { size: 16 })
    ]
  }
), ze = h.canvas`
    display: block;
    width: 100%;
    height: 24px;
    color: inherit;
`, je = 512, Ve = 4, qe = ({
  mediaStream: e
}) => {
  const t = new AudioContext(), n = t.createMediaStreamSource(e), o = t.createAnalyser();
  o.fftSize = je, n.connect(o);
  const s = new Float32Array(o.fftSize);
  return { readLevel: () => {
    o.getFloatTimeDomainData(s);
    let c = 0;
    for (let f = 0; f < s.length; f += 1)
      c += s[f] * s[f];
    const y = Math.sqrt(c / s.length);
    return Math.min(1, y * Ve);
  }, stopMonitor: () => {
    n.disconnect(), t.close();
  } };
}, B = 2, He = 2, Ge = 2, Xe = 50, Ye = ({ mediaStream: e }) => {
  const t = x(null);
  return P(() => {
    const n = t.current;
    if (!n)
      return;
    const o = qe({ mediaStream: e }), s = window.devicePixelRatio || 1, a = n.clientWidth, u = n.clientHeight;
    n.width = a * s, n.height = u * s;
    const c = n.getContext("2d");
    if (!c) {
      o.stopMonitor();
      return;
    }
    c.scale(s, s);
    const y = B + He, f = Math.max(1, Math.floor(a / y)), l = [];
    let k = 0, E = 0;
    const S = (w) => {
      w - E >= Xe && (E = w, l.push(o.readLevel()), l.length > f && l.shift()), c.clearRect(0, 0, a, u), c.fillStyle = getComputedStyle(n).color, l.forEach((M, R) => {
        const T = Math.max(Ge, M * u), m = a - (l.length - R) * y, b = (u - T) / 2;
        c.beginPath(), c.roundRect(m, b, B, T, B / 2), c.fill();
      }), k = requestAnimationFrame(S);
    };
    return k = requestAnimationFrame(S), () => {
      cancelAnimationFrame(k), o.stopMonitor();
    };
  }, [e]), /* @__PURE__ */ i(ze, { ref: t, "aria-hidden": "true" });
}, Ze = ({ elapsedSeconds: e }) => {
  const t = Math.floor(e / 60), n = e % 60;
  return `${t}:${String(n).padStart(2, "0")}`;
}, Je = F`
    0%, 100% {
        opacity: 1;
    }
    50% {
        opacity: 0.3;
    }
`, Ke = h.div`
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 6px 8px;
    border-radius: 0 0 8px 8px;
    background-color: hsl(var(--background));
`, Qe = h.span`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: hsl(0 84% 60%);
    animation: ${Je} 1.2s ease-in-out infinite;
    ${W}
    flex-shrink: 0;
`, et = h.span`
    font-size: 12px;
    font-variant-numeric: tabular-nums;
    color: hsl(var(--foreground));
    min-width: 32px;
    flex-shrink: 0;
`, tt = h.div`
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    color: hsl(0 84% 60%);
`, nt = h.span`
    flex: 1;
    font-size: 12px;
    color: hsl(var(--muted-foreground));
`, rt = h.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background-color: transparent;
    color: hsl(var(--muted-foreground));
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;

    &:hover {
        background-color: hsl(var(--accent));
        color: hsl(var(--accent-foreground));
    }

    &:active {
        transform: scale(0.95);
    }
`, ot = h.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    border-radius: 50%;
    background-color: hsl(0 84% 60%);
    color: white;
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);

    &:hover:not(:disabled) {
        background-color: hsl(0 84% 52%);
        transform: scale(1.05);
    }

    &:active:not(:disabled) {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`, gt = ({ mediaStream: e, isConnecting: t, onCancel: n, onConfirm: o }) => {
  const [s, a] = A(0);
  return P(() => {
    if (t)
      return;
    const u = setInterval(() => {
      a((c) => c + 1);
    }, 1e3);
    return () => clearInterval(u);
  }, [t]), /* @__PURE__ */ N(Ke, { role: "status", "aria-label": "Recording voice message", children: [
    /* @__PURE__ */ i(Qe, {}),
    /* @__PURE__ */ i(et, { "aria-live": "off", children: Ze({ elapsedSeconds: s }) }),
    t || !e ? /* @__PURE__ */ i(nt, { children: "Connecting..." }) : /* @__PURE__ */ i(tt, { children: /* @__PURE__ */ i(Ye, { mediaStream: e }) }),
    /* @__PURE__ */ i(
      rt,
      {
        type: "button",
        onClick: n,
        "aria-label": "Cancel dictation",
        title: "Cancel dictation",
        children: /* @__PURE__ */ i(Q, { size: 16 })
      }
    ),
    /* @__PURE__ */ i(
      ot,
      {
        type: "button",
        onClick: o,
        disabled: t,
        "aria-label": "Stop and insert transcription",
        title: "Stop and insert transcription",
        children: /* @__PURE__ */ i(Ae, { size: 16 })
      }
    )
  ] });
}, st = h.div`
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0 8px 6px;
    padding: 6px 10px;
    border-radius: 6px;
    background-color: hsl(0 84% 60% / 0.1);
    border: 1px solid hsl(0 84% 60% / 0.25);
`, at = h.span`
    flex: 1;
    font-size: 12px;
    line-height: 1.4;
    color: hsl(0 72% 45%);
`, ct = h.button`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    border: none;
    border-radius: 4px;
    background-color: transparent;
    color: hsl(0 72% 45%);
    cursor: pointer;
    transition: all 0.15s ease;
    flex-shrink: 0;

    &:hover {
        background-color: hsl(0 84% 60% / 0.15);
    }
`, bt = ({ message: e, onDismiss: t }) => /* @__PURE__ */ N(st, { role: "alert", children: [
  /* @__PURE__ */ i(at, { children: e }),
  /* @__PURE__ */ i(
    ct,
    {
      type: "button",
      onClick: t,
      "aria-label": "Dismiss error",
      title: "Dismiss",
      children: /* @__PURE__ */ i(Q, { size: 14 })
    }
  )
] });
export {
  ht as ChatUI,
  ft as MicButton,
  gt as RecordingBar,
  bt as VoiceErrorBanner,
  Ye as VoiceWaveform,
  mt as useVoiceTranscription
};
